<template >
  <div id="app" class="common-container" style="overflow:hidden">
    <div style="display:none"><input type="text" tabindex="0"></div>
    <preloader></preloader>
    <Navber />
    <router-link to="/home"></router-link>
    <div v-if="$root.hideSearch == true">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <Footer />
  </div>
</template>
<script>
import Navber from "./view/navber.vue";
import Footer from "./view/footer.vue";
import Preloader from "./components/Activity/preloader";
export default {
  name: "App",

  components: {
    Navber: Navber,
    Footer: Footer,
    preloader: Preloader,
  },
};
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}
.container_class {
  overflow: hidden;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(100em);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
#app {
  overflow: hidden;
  width: 100vw;
}
@font-face {
  font-family: "Kalpurush";
  src: url("/assets/css/kalpurush.eot");
  src: url("/assets/css/kalpurush.woff") format("woff"),
    url("/assets/css/kalpurush.ttf") format("truetype"),
    url("/assets/css/kalpurush.svg#Kalpurush") format("svg"),
    url("/assets/css/kalpurush.eot?#iefix") format("embedded-opentype");
  font-weight: normal;
  font-style: normal;
}
#block_landscape {
  display: none;
}
html,
body {
  min-height: 100%;
  font-family: "Kalpurush";
  position: static !important;
}
/* .container_class {
      overflow: hidden;
    } */
@import "assets/css/style.css";
@import "assets/css/custom.css";
@import "assets/css/meanmenu.css";
@import "assets/css/settings.css";
@import "assets/css/activity.css";
@import "/assets/scss/carousel.scss";
</style>
